import React from 'react';

import ProgressGoalsTable from './components/ProgressGoalsTable';
import ProgressTowardsGoalsSection from './components/ProgressTowardsGoalsSection';
import StrengthAssessmentSection from './components/StrengthAssessmentSection';
import LookerDashboardLayout from '../../components/LookerDashboardLayout';
import { SectionHeader } from '../../components/SectionHeader';

const LookerImpactDashboard = () => {
  return (
    <LookerDashboardLayout>
      <StrengthAssessmentSection />
      <ProgressGoalsTable />
      <SectionHeader i18title="impact.progress.goals.title" i18description="impact.progress.goals.description" />
      <ProgressTowardsGoalsSection />
    </LookerDashboardLayout>
  );
};

export default LookerImpactDashboard;
